import { combineReducers } from 'redux';
import entryManager from './entryManager.reducer.js';

const reducers = combineReducers({
    entryManager,
});

export default reducers;
